webpackJsonp([162898551421021],{

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _reactHelmet = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
		return _react2.default.createElement(
			_gatsbyPluginPageTransitions2.default,
			null,
			_react2.default.createElement(
				'div',
				{ className: 'Atrakeur-Page' },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					null,
					_react2.default.createElement('meta', { charSet: 'utf-8' }),
					_react2.default.createElement(
						'title',
						null,
						'Atrakeur: DIY, Mod\xE9lisme et Web'
					)
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'h1',
						null,
						'NOT FOUND'
					),
					_react2.default.createElement(
						'p',
						null,
						'You just hit a route that doesn\'t exist... the sadness.'
					)
				)
			)
		);
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-80a89261b6ea0310a245.js